import { FIREBASE_EVENT_NAMES, FIREBASE_EVENT_PARAMS } from "utils/Constants";
import { Image, Linking, StyleSheet, View } from "react-native";
import React, { useRef, useState } from "react";
import Svg, { Path } from "react-native-svg";
import { fp, hp, spH, spV, wp } from "utils/normalise";
import { useDispatch, useSelector } from "react-redux";
import { useGlobalSearchParams, useRouter } from "expo-router";

import { ANALYTICS_EVENT_NAMES } from "utils/analytics";
import { Images } from "assets";
import { TouchableOpacity } from "react-native-gesture-handler";
import VText from "components/VText";
import { analytics } from "utils/firebaseConfig";
import { logEvent } from "firebase/analytics";
import { trackV2 } from "utils/Segment";
import { Link } from "expo-router";
import Heading from "./Heading";
import Paragraph from "./Pharagraph";

const Footer = () => {
    const router = useRouter();
    const global = useGlobalSearchParams();
    const gender = global?.gender ?? "female";

    return (
                
      <footer>
          <View style={styles.container}>
            <Svg
                style={{
                    paddingTop: spV(28),
                    paddingBottom: spV(36),
                }}
                width="98"
                height="37"
                viewBox="0 0 98 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <Path
                    d="M0 10.7137H7.32824L12.5267 29.126L17.8397 10.7137H24.8473L15.8473 35.6756H8.9542L0 10.7137Z"
                    fill="white"
                />
                <Path
                    d="M49.9237 28.3473C49.7557 29.8282 48.9847 31.3321 47.6107 32.8588C45.4733 35.2863 42.4809 36.5 38.6336 36.5C35.458 36.5 32.6565 35.4771 30.229 33.4313C27.8015 31.3855 26.5878 28.0573 26.5878 23.4466C26.5878 19.126 27.6794 15.813 29.8626 13.5076C32.0611 11.2023 34.9084 10.0496 38.4046 10.0496C40.4809 10.0496 42.3511 10.4389 44.0153 11.2176C45.6794 11.9962 47.0534 13.2252 48.1374 14.9046C49.1145 16.3855 49.7481 18.1031 50.0382 20.0573C50.2061 21.2023 50.2748 22.8511 50.2443 25.0038H33.1603C33.2519 27.5076 34.0382 29.2634 35.5191 30.271C36.4198 30.8969 37.5038 31.2099 38.771 31.2099C40.1145 31.2099 41.2061 30.8282 42.0458 30.0649C42.5038 29.6527 42.9084 29.0802 43.2595 28.3473H49.9237ZM43.4656 20.6985C43.3588 18.9733 42.8321 17.6679 41.8855 16.7824C40.9542 15.8817 39.7939 15.4313 38.4046 15.4313C36.8931 15.4313 35.7176 15.9046 34.8779 16.8511C34.0534 17.7977 33.5344 19.0802 33.3206 20.6985H43.4656ZM35.9313 0.5H41.7939L47.1527 7.34733H41.8397L38.8626 3.5L35.8626 7.34733H30.5496L35.9313 0.5Z"
                    fill="white"
                />
                <Path
                    d="M66.0916 31.0267V35.9046L63 36.0191C59.916 36.126 57.8092 35.5916 56.6794 34.416C55.9466 33.6679 55.5802 32.5153 55.5802 30.958V15.5916H52.0992V10.9427H55.5802V3.98092H62.0382V10.9427H66.0916V15.5916H62.0382V28.7824C62.0382 29.8053 62.1679 30.4466 62.4275 30.7061C62.687 30.9504 63.4809 31.0725 64.8092 31.0725C65.0076 31.0725 65.2137 31.0725 65.4275 31.0725C65.6565 31.0573 65.8779 31.042 66.0916 31.0267Z"
                    fill="white"
                />
                <Path
                    d="M76.9924 10.7137V35.6756H70.374V10.7137H76.9924ZM76.9924 1.71374V7.73664H70.374V1.71374H76.9924Z"
                    fill="white"
                />
                <Path
                    d="M95.8855 16.7366C93.2595 16.7366 91.4962 17.5916 90.5954 19.3015C90.0916 20.2634 89.8397 21.7443 89.8397 23.7443V35.6756H83.2672V10.7137H89.4962V15.0649C90.5038 13.4008 91.3817 12.2634 92.1298 11.6527C93.3511 10.6298 94.9389 10.1183 96.8931 10.1183C97.0153 10.1183 97.1145 10.126 97.1908 10.1412C97.2824 10.1412 97.4733 10.1489 97.7634 10.1641V16.8511C97.3511 16.8053 96.9847 16.7748 96.6641 16.7595C96.3435 16.7443 96.084 16.7366 95.8855 16.7366Z"
                    fill="white"
                />
            </Svg>

            <View style={styles.footerContainer}>
                <View style={styles.leftContainer}>
                    <View style={styles.footerLinksContainer}>

                        
                        <VText style={styles.footerText}>
                            <Link 
                            onPress={() => {
                                const eventData = {
                                    link_name: "About Us",
                                };
                                trackV2(ANALYTICS_EVENT_NAMES.FOOTER_LINK_CLICKED, eventData);
                            }} aria-label="About Us" href={`/about?gender=${gender}`} >
                                About
                            </Link>
                        </VText>

                        {/* <VText
                            onPress={() => {
                                logEvent(analytics, FIREBASE_EVENT_NAMES.FOOTER_CLICKED, {
                                    [FIREBASE_EVENT_PARAMS.CLICKED_FROM]: "CONTACT_US_CLICKED",
                                });
                                router.push(`/contact-us?gender=${gender}`);
                            }}
                            text="Contact Us"
                            style={styles.footerText}
                        /> */}

                      
                        <VText
                            style={styles.footerText}
                        >
                            <Link 
                            onPress={() => {
                                const eventData = {
                                    link_name: "Affiliate",
                                };
                                trackV2(ANALYTICS_EVENT_NAMES.FOOTER_LINK_CLICKED, eventData);
                                router.push(`/affiliate?gender=${gender}`);
                            }} aria-label="Affiliate" href={`/affiliate?gender=${gender}`} >
                                Affiliate
                            </Link>
                        </VText>

                        <VText
                            style={styles.footerText}
                        >
                            <Link 
                            onPress={() => {
                                const eventData = {
                                    link_name: "Terms & Conditions",
                                };
                                trackV2(ANALYTICS_EVENT_NAMES.FOOTER_LINK_CLICKED, eventData);
;
                            }} aria-label="Terms & Conditions" href={`/terms-and-conditions?gender=${gender}`} >
                                Terms & Conditions
                            </Link>
                        </VText>

                        <VText
                            style={styles.footerText}
                        >
                            <Link 
                            onPress={() => {
                                const eventData = {
                                    link_name: "Privacy Policy",
                                };
                                trackV2(ANALYTICS_EVENT_NAMES.FOOTER_LINK_CLICKED, eventData);

                            }} aria-label="Privacy Policy" href={`/privacy-policy?gender=${gender}`} >
                                Privacy Policy
                            </Link>
                        </VText>

                        <VText
                            style={styles.footerText}
                        >
                            <Link 
                            onPress={() => {
                                const eventData = {
                                    link_name: "Returns & Exchanges Policy",
                                };
                                trackV2(ANALYTICS_EVENT_NAMES.FOOTER_LINK_CLICKED, eventData);
                            }} aria-label="Returns & Exchanges Policy" href={`/returns-and-exchanges?gender=${gender}`} >
                                Returns & Exchanges Policy
                            </Link>
                        </VText>
                    </View>
                </View>
                <View style={styles.rightContainer}>
                    <Heading  type="h2" style={styles.footerHeading} >
                    Download Our App
                    </Heading>
                    <VText
                        style={{
                            ...styles.footerText,
                            width: wp(270),
                            textAlign: "left",
                            marginTop: spV(12),
                            marginTop: spV(16),
                        }}
                    >
                        <Paragraph>
                            Scan the QR code with your iOS to download the app
                        </Paragraph>
                      
                        </VText>
                    <Image
                        accessibilityLabel="Download Our App"
                        // resizeMode="cover"
                        source={Images.appQR}
                        style={styles.footerQR}
                    />
                </View>
            </View>

            <View style={styles.footerBottom}>
                <VText
                    text="© 2024 Vêtir. All Rights Reserved."
                    style={[styles.footerText, { marginBottom: 0, marginTop: spV(4) }]}
                />
                <View
                    style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        gap: spH(10),
                    }}
                >
                    <Link onPress={() => {
                            logEvent(analytics, FIREBASE_EVENT_NAMES.FOOTER_CLICKED, {
                                [FIREBASE_EVENT_PARAMS.CLICKED_FROM]: "INSTAGRAM_CLICKED",
                            });
                        }}  href="https://www.instagram.com/vetirapp" aria-label="Instagram" target="_blank" rel="noopener noreferrer"  >
                    <TouchableOpacity
                        style={{}}
                        
                    >
                        <Svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <Path
                                d="M20.2297 6.92583C19.9528 6.92583 19.6821 7.00794 19.4519 7.16177C19.2216 7.3156 19.0422 7.53425 18.9362 7.79007C18.8303 8.04589 18.8026 8.32738 18.8566 8.59895C18.9106 8.87053 19.0439 9.11998 19.2397 9.31578C19.4355 9.51157 19.685 9.64491 19.9565 9.69893C20.2281 9.75295 20.5096 9.72522 20.7654 9.61926C21.0212 9.5133 21.2399 9.33385 21.3937 9.10363C21.5476 8.8734 21.6297 8.60272 21.6297 8.32583C21.6297 7.95452 21.4822 7.59843 21.2196 7.33588C20.9571 7.07333 20.601 6.92583 20.2297 6.92583ZM25.5963 9.74916C25.5737 8.78117 25.3924 7.82346 25.0597 6.91416C24.763 6.13615 24.3013 5.43165 23.7063 4.84916C23.1286 4.25116 22.4225 3.79237 21.6413 3.50749C20.7344 3.16468 19.7757 2.97924 18.8063 2.95916C17.5697 2.88916 17.173 2.88916 13.9997 2.88916C10.8263 2.88916 10.4297 2.88916 9.19301 2.95916C8.22369 2.97924 7.26491 3.16468 6.35801 3.50749C5.5783 3.79525 4.87276 4.25365 4.29301 4.84916C3.695 5.42687 3.23621 6.13301 2.95134 6.91416C2.60853 7.82106 2.42309 8.77984 2.40301 9.74916C2.33301 10.9858 2.33301 11.3825 2.33301 14.5558C2.33301 17.7292 2.33301 18.1258 2.40301 19.3625C2.42309 20.3318 2.60853 21.2906 2.95134 22.1975C3.23621 22.9786 3.695 23.6848 4.29301 24.2625C4.87276 24.858 5.5783 25.3164 6.35801 25.6042C7.26491 25.947 8.22369 26.1324 9.19301 26.1525C10.4297 26.2225 10.8263 26.2225 13.9997 26.2225C17.173 26.2225 17.5697 26.2225 18.8063 26.1525C19.7757 26.1324 20.7344 25.947 21.6413 25.6042C22.4225 25.3193 23.1286 24.8605 23.7063 24.2625C24.304 23.6822 24.7661 22.9771 25.0597 22.1975C25.3924 21.2882 25.5737 20.3305 25.5963 19.3625C25.5963 18.1258 25.6663 17.7292 25.6663 14.5558C25.6663 11.3825 25.6663 10.9858 25.5963 9.74916ZM23.4963 19.2225C23.4878 19.9631 23.3537 20.6968 23.0997 21.3925C22.9134 21.9002 22.6142 22.359 22.2247 22.7342C21.8463 23.1198 21.3884 23.4183 20.883 23.6092C20.1873 23.8632 19.4536 23.9973 18.713 24.0058C17.5463 24.0642 17.1147 24.0758 14.0463 24.0758C10.978 24.0758 10.5463 24.0758 9.37967 24.0058C8.61071 24.0202 7.84503 23.9018 7.11634 23.6558C6.63309 23.4552 6.19626 23.1574 5.83301 22.7808C5.44578 22.406 5.15032 21.9469 4.96967 21.4392C4.68484 20.7335 4.52686 19.9831 4.50301 19.2225C4.50301 18.0558 4.43301 17.6242 4.43301 14.5558C4.43301 11.4875 4.43301 11.0558 4.50301 9.88916C4.50824 9.13206 4.64645 8.38176 4.91134 7.67249C5.11673 7.18006 5.43198 6.74109 5.83301 6.38916C6.18746 5.98802 6.62551 5.66944 7.11634 5.45583C7.82748 5.19921 8.577 5.06509 9.33301 5.05916C10.4997 5.05916 10.9313 4.98916 13.9997 4.98916C17.068 4.98916 17.4997 4.98916 18.6663 5.05916C19.4069 5.06765 20.1407 5.20178 20.8363 5.45583C21.3665 5.65259 21.8423 5.97248 22.2247 6.38916C22.607 6.74753 22.9057 7.18568 23.0997 7.67249C23.359 8.38292 23.4932 9.1329 23.4963 9.88916C23.5547 11.0558 23.5663 11.4875 23.5663 14.5558C23.5663 17.6242 23.5547 18.0558 23.4963 19.2225ZM13.9997 8.57083C12.8165 8.57313 11.6605 8.92611 10.6778 9.58515C9.69508 10.2442 8.92978 11.1797 8.47858 12.2735C8.02738 13.3674 7.91052 14.5704 8.14277 15.7306C8.37502 16.8908 8.94595 17.9561 9.78343 18.792C10.6209 19.6278 11.6874 20.1967 12.848 20.4267C14.0087 20.6567 15.2115 20.5375 16.3044 20.0841C17.3973 19.6308 18.3314 18.8637 18.9885 17.8797C19.6456 16.8957 19.9963 15.7391 19.9963 14.5558C19.9979 13.7684 19.8437 12.9885 19.5428 12.2609C19.2418 11.5333 18.8 10.8724 18.2427 10.3162C17.6854 9.76 17.0236 9.31945 16.2954 9.01991C15.5673 8.72037 14.787 8.56775 13.9997 8.57083ZM13.9997 18.4408C13.2313 18.4408 12.4802 18.213 11.8413 17.7861C11.2024 17.3592 10.7044 16.7524 10.4104 16.0426C10.1164 15.3327 10.0394 14.5515 10.1893 13.7979C10.3392 13.0443 10.7092 12.352 11.2526 11.8087C11.7959 11.2654 12.4881 10.8954 13.2417 10.7455C13.9954 10.5956 14.7765 10.6725 15.4864 10.9666C16.1963 11.2606 16.803 11.7586 17.2299 12.3974C17.6568 13.0363 17.8847 13.7874 17.8847 14.5558C17.8847 15.066 17.7842 15.5712 17.5889 16.0426C17.3937 16.5139 17.1075 16.9422 16.7468 17.3029C16.386 17.6637 15.9577 17.9499 15.4864 18.1451C15.015 18.3403 14.5099 18.4408 13.9997 18.4408Z"
                                fill="white"
                            />
                        </Svg>
                    </TouchableOpacity>
                    </Link>
                    <Link  onPress={() => {
                            logEvent(analytics, FIREBASE_EVENT_NAMES.FOOTER_CLICKED, {
                                [FIREBASE_EVENT_PARAMS.CLICKED_FROM]: "TIKTOK_CLICKED",
                            });
                        }}  href="https://www.tiktok.com/@vetirapp" aria-label="TikTok" target="_blank" rel="noopener noreferrer" >
                    <TouchableOpacity

                       
                    >
                        <Svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <Path
                                d="M22.4006 13.2022V9.88886C20.8489 9.88886 19.6648 9.4747 18.9006 8.6697C18.1163 7.75098 17.6769 6.58752 17.6581 5.3797V5.14053L14.5256 5.0647V18.5222C14.4181 19.1094 14.1331 19.6494 13.709 20.0695C13.2849 20.4895 12.7421 20.7693 12.154 20.8711C11.5658 20.9729 10.9605 20.8918 10.4199 20.6387C9.87934 20.3856 9.4294 19.9727 9.13087 19.4558C8.83234 18.9389 8.69959 18.3429 8.75055 17.7482C8.80151 17.1534 9.03371 16.5886 9.41582 16.1301C9.79793 15.6715 10.3115 15.3412 10.8873 15.1838C11.4631 15.0263 12.0733 15.0493 12.6356 15.2497V12.0414C12.3078 11.9876 11.9761 11.9603 11.6439 11.9597C10.4487 11.9597 9.28025 12.3141 8.28643 12.9782C7.2926 13.6422 6.51802 14.5861 6.06061 15.6903C5.6032 16.7946 5.48353 18.0097 5.71671 19.182C5.94989 20.3543 6.52546 21.4311 7.37064 22.2763C8.21582 23.1215 9.29263 23.6971 10.4649 23.9302C11.6372 24.1634 12.8523 24.0437 13.9566 23.5863C15.0609 23.1289 16.0047 22.3543 16.6688 21.3605C17.3328 20.3667 17.6873 19.1983 17.6873 18.003C17.6866 17.7554 17.671 17.508 17.6406 17.2622V11.9247C19.065 12.8142 20.7222 13.259 22.4006 13.2022Z"
                                fill="white"
                            />
                        </Svg>
                    </TouchableOpacity>
                    </Link>
                </View>
            </View>
        </View>
      </footer>
    );
};

const styles = StyleSheet.create({
    container: {
        backgroundColor: "black",
        paddingHorizontal: spH(60),
        paddingVertical: spV(30),
        paddingTop: 0,
        width: "auto",
    },
    footerHeading: {
        color: "white",
        fontSize: fp(20),
        fontWeight: "400",
        fontFamily: "LibreBodoni",
        textAlign: "left",
        fontStyle: "normal",
    },
    footerContainer: {
        flexDirection: "row",
        justifyContent: "space-between",
    },

    footerLinksContainer: {
        color: "white",
        fontSize: fp(15),
        fontFamily: "JosefinSans",
        textAlign: "left",
    },

    leftContainer: {},
    rightContainer: {},
    footerText: {
        color: "white",
        fontSize: fp(12),
        fontWeight: "350",
        fontFamily: "JosefinSans",
        textAlign: "left",
        fontStyle: "normal",
        marginBottom: spV(16),
    },
    footerQR: {
        width: wp(100),
        height: wp(100),
        borderRadius: 5,
    },
    footerBottom: {
        flexDirection: "row",
        justifyContent: "space-between",
        borderTopWidth: 1,
        borderTopColor: "rgba(255, 255, 255, 0.3)",
        width: "100%",
        paddingTop: spV(20),
        marginTop: spV(30),
        paddingRight: spH(0),
        alignItems: "center",
    },
    footerBottomIcons: {
        padding: spH(10),
        height: hp(32),
    },
});

export default React.memo(Footer);
